export default __webpack_public_path__ + "static/media/03E58071-155A-47E0-815E-DA6798C2D53F_1_105_c.dab68527.jpeg";